var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"flex space-x-4 tabs tabs-border mt-6"},_vm._l((_vm.tabs),function(tab,index){return _c('div',{key:tab.elm.title,class:{ 'tab-header': index == _vm.selectedIndex },on:{"click":function($event){return _vm.selectTab(index)}}},[_vm._v(" "+_vm._s(tab.elm.title)+" ")])}),0),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }